<template>
    <div
        v-if="attachments"
        class="uploads"
        :class="{'highlight': highlight}"
        @dragenter.stop.prevent="highlight = true"
        @dragover.stop.prevent="highlight = true"
        @dragleave.stop.prevent="highlight = false"
        @drop.stop.prevent="drop">

        <span class="subtitle middle-sidebar-title is-5 has-text-weight-bold">
            <i @click="$emit('toggle_attachments')"
               class="icon fas fa-times close has-text-grey pointer"></i> &nbsp;
            Attachments
        </span><br/><br/>

        <div v-if="error" class="notification is-danger">{{error}}</div>

        <label
            v-if="is_editable"
            class="button is-block themed-button"
            :class="{'is-loading': $store.state.attachments.create.loading}">

            <span class="icon"><i class="fas fa-plus"></i></span>
            <span>Upload file</span>
            <input type="file" class="is-hidden" @change="change"/>
        </label><br/>

        <note-details-attachment
            v-for="attachment in attachments"
            :note="note"
            :space="space"
            :key="attachment.id"
            :attachment="attachment"
            :is_editable="is_editable"/>

        <div class="has-text-grey has-text-centered">
            To upload file click "Upload file" button or drug-n-drop file here.
        </div>
    </div>
</template>

<script>
import NoteDetailsAttachment from './NoteDetailsAttachment.vue';

export default {
    name: 'AttachmentList',
    props: ['space', 'note', 'is_editable', 'attachments'],
    components: { NoteDetailsAttachment },
    data() {
        return { highlight: false, error: null };
    },
    methods: {
        change(event) {
            this.upload(event.target.files[0]);
        },
        drop(event) {
            this.highlight = false;
            const { files } = event.dataTransfer;
            if (files.length === 0) return;
            this.upload(files[0]);
        },
        upload(file) {
            const max_size = this.space.max_attachment_size;
            const form = new FormData();
            form.append('file', file);

            if (file.size / 1000 / 1000 > max_size) {
                this.error = `Uploading file size can't be greater then ${max_size}mb.`;
                return;
            }

            this.$store.dispatch('attachments/create', {
                space_id: this.space.id,
                note_id: this.note.id,
                data: form,
            });
        },
    },
};
</script>

<style scoped>
    .uploads {
        position: -webkit-sticky;
        position: sticky;
        top: 1.2rem;
        width: 25rem;
    }

    .highlight {
        background: #d9d9d9 !important;
    }
</style>
